import { render, staticRenderFns } from "./property-location.vue?vue&type=template&id=bda36a16&"
import script from "./property-location.vue?vue&type=script&lang=js&"
export * from "./property-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports